// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewCard_container__Evf60","a":"ReviewCard_a__YUZxn","star":"ReviewCard_star__STg20","reviewBody":"ReviewCard_reviewBody__WqOLQ"};